<template lang="html">
    <router-link id="skillScore" :to="{ name: 'playerSkills' }">
        <span class="title"
            >Practice drills:
            <span class="score"
                ><i>{{ score }}</i> / {{ total }}</span
            ></span
        >
        <img class="star" src="~@/assets/icons/goals-light-green-small.svg" />

        <div class="graph">
            <span v-for="skill in skills" :key="skill.id"
                ><i :style="{ width: percentage(skill.score) + '%' }"
            /></span>
        </div>
        <chevron-right-icon class="icon" style="margin-right: 4px"></chevron-right-icon>
    </router-link>
</template>

<script>
import { ChevronRightIcon } from "vue-feather-icons";
export default {
    name: "skill-score",
    components: { ChevronRightIcon },
    computed: {
        total() {
            return this.$store.state.user.skills.length * 10;
        },
        score() {
            return this.$store.state.user.skills.reduce((sum, skill) => {
                return sum + skill.score;
            }, 0);
        },
        skills() {
            return this.$store.state.user.skills;
        },
    },
    methods: {
        percentage(score) {
            return (score / 10) * 100;
        },
    },
};
</script>

<style lang="scss" scoped>
#skillScore {
    display: block;
    text-decoration: none;
    border-radius: 15px;
    margin-bottom: 10px;
    padding: 20px;
    position: relative;
    clear: both;
    width: 100%;
    background: $green_0;
    padding-bottom: 30px;
    .icon {
        color: white;
        position: absolute;
        bottom: 10px;
        right: 10px;
    }
    .title {
        color: white;
        display: block;
        margin-bottom: 20px;
    }

    .score {
        color: white;
        i {
            font-size: 22px;
        }
    }
    .star {
        position: absolute;
        right: 15px;
        top: 15px;
    }
    .graph {
        //position:absolute;
        top: 20px;
        left: calc(50% - 38px);
        width: calc(100% - 30px);
        span {
            display: inline-block;
            width: 100%;
            height: 8px;
            background: #0d313a;
            margin-right: 5px;
            border-radius: 5px;
            position: relative;
            overflow: hidden;
            &:last-of-type {
                margin-right: 0px;
            }
            i {
                display: block;
                position: absolute;
                bottom: 0px;
                height: 8px;
                background: rgb(21, 242, 159);
                background: linear-gradient(
                    -90deg,
                    rgba(21, 242, 159, 1) 0%,
                    rgba(38, 121, 98, 1) 100%
                );
                width: 50%;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
            }
        }
    }
}
</style>
